// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3zBnY","unreadBadge":"styles_unreadBadge__26RiN","modalContent":"styles_modalContent__2J6rG","modal":"styles_modal__3RsXE"};